import { Popover } from '@mui/material'
import {
  Icon,
  FilterTitle,
  ButtonBase,
  DataGridContainer,
} from './DataGridFilter.style'
import { useTranslation } from 'react-i18next'
import { DataGrid, DataGridProps } from '@mui/x-data-grid'
import { useIsSmaller, usePopover } from 'shared/hooks'
import { Box, Button, Typography } from '@mui/material'
import type { SxProps, Theme } from '@mui/material'

interface DataGridFilterProps {
  dataGridProps: DataGridProps
  title: string
  selectedFilterCount: number
  onRetry?: () => void
  onOpen?: () => void
  containerSx?: SxProps<Theme>
}

const DataGridFilter = ({
  dataGridProps,
  title,
  selectedFilterCount,
  onRetry,
  onOpen,
  containerSx,
}: DataGridFilterProps) => {
  const { t } = useTranslation()
  const isMobile = useIsSmaller('md')

  const [anchorEl, isPopoverOpen, openPopover, closePopover] = usePopover()

  const hasError = Boolean((dataGridProps as any)?.error)
  const isLoading = Boolean(dataGridProps?.loading)

  return (
    <>
      <ButtonBase
        onClick={e => {
          onOpen?.()
          openPopover(e)
        }}
      >
        <Icon />
        <FilterTitle>{`${t(title)} ${
          selectedFilterCount > 0 ? `(${selectedFilterCount})` : ''
        }`}</FilterTitle>
      </ButtonBase>
      <Popover
        open={isPopoverOpen}
        anchorEl={anchorEl}
        onClose={closePopover}
        disableScrollLock={isMobile}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        PaperProps={
          isMobile
            ? {
                sx: {
                  maxHeight: 'calc(100dvh - 16px)',
                  overflow: 'auto',
                  WebkitOverflowScrolling: 'touch',
                  touchAction: 'pan-x pan-y',
                },
              }
            : undefined
        }
      >
        <DataGridContainer
          isLoading={isLoading}
          isMobile={isMobile}
          sx={containerSx}
        >
          {hasError ? (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              height="100%"
              gap={2}
              px={2}
              textAlign="center"
            >
              <Typography variant="body1">
                {t('error.somethingWentWrong')}
              </Typography>
              {onRetry && (
                <Button
                  variant="contained"
                  onClick={onRetry}
                  disabled={isLoading}
                >
                  {t('error.reset')}
                </Button>
              )}
            </Box>
          ) : (
            <DataGrid {...dataGridProps} />
          )}
        </DataGridContainer>
      </Popover>
    </>
  )
}

export default DataGridFilter
